module.exports = __webpack_public_path__ + "img/Tifa.0eabf84.png";